import { Pipe, PipeTransform } from '@angular/core';
import { NavItemId } from '../../../../../../models/enum/shared/nav-item-id.enum';
import { NavItem } from '../models/nav-item';

const navItemTestIdSlugs: Record<NavItemId, string> = {
  [NavItemId.Home]: 'home',
  [NavItemId.HighGuide]: 'high-guide',
  [NavItemId.Products]: 'products',
  [NavItemId.Locations]: 'locations',
  [NavItemId.Templates]: 'templates',
  [NavItemId.Menus]: 'menus',
  [NavItemId.Displays]: 'displays',
  [NavItemId.Settings]: 'settings',
  [NavItemId.Profile]: 'profile',
  [NavItemId.Help]: 'help',
  [NavItemId.CurrentLocation]: 'current-location',
  [NavItemId.SignOut]: 'sign-out'
};

// NavItemId is numeric, so the E2E test id needs its own stable slug per item.
@Pipe({
  name: 'navItemTestId',
  standalone: false
})
export class NavItemTestIdPipe implements PipeTransform {
  transform(navItem: NavItem): string {
    return `nav-${navItemTestIdSlugs[navItem?.id]}`;
  }
}
